namespace Areas.OneTimeUploads {
    "use strict";

    export function gotoOneTimeUpload() {
        location.href = "/OneTimeUploads/List/Index";
    }

    export function gotoCreate() {
        location.href = "/OneTimeUploads/Create/Index";
    }

    export function gotoCopyFromGrid() {
        Areas.gotoSelected("OneTimeUploadsGrid", "/OneTimeUploads/Create/DuplicateRecord/");
    }

    export function gotoEdit() {
        Areas.gotoSelected("OneTimeUploadsGrid", "/OneTimeUploads/Edit/Index/");
    }

    const viewUrl = "/OneTimeUploads/View/Index/";

    export function gotoView() {
        Areas.gotoSelected("OneTimeUploadsGrid", viewUrl);
    }

    export function viewLink(cellElement, cellInfo) {
        buildCellContent(cellElement, () => { return cellInfo.data.oneTimeUploadId; },
            `<a href= '${viewUrl}{placeholder}'>View</a>`);
    }

    export function gotoCopyFromForm() {
        const keyId: any = Areas.getOptionFromForm("OneTimeUploadForm", "KeyId");
        
        if (keyId != null) {
            location.href = `/OneTimeUploads/Create/DuplicateRecord/${keyId}`;
        }
        else {
            DevExpress.ui.notify("Record to copy not selected.  Use List instead!", "warning", 2000);
        }
    }

}